(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-library"]) return;
  try {
    
  (() => {
    const nameOverrides = {
      'baby-alive': 'Baby Alive',
      'barbie-signature': 'Barbie Signature',
      'bburago': 'Bburago',
      'cars': 'Cars',
      'dc-comics': 'DC Comics',
      'fast-furious': 'Fast & Furious',
      'five-nights-at-freddys': "Five Nights at Freddy's",
      'gabbys-dollhouse': "Gabby's Dollhouse",
      'hot-wheels': 'Hot Wheels',
      'jurassic-world': 'Jurassic World',
      'little-live-pets': 'Little Live Pets',
      'lol-surprise': 'L.O.L. Surprise!',
      'my-little-pony': 'My Little Pony',
      'nerf': 'Nerf',
      'neddoh': 'NeeDoh',
      'patrulha-pata': 'Patrulha Pata',
      'pj-masks': 'PJ Masks',
      'play-doh': 'Play-Doh',
      'pokemon': 'Pokémon',
      'cartas-pokemon': 'Cartas Pokémon',
      'polly-pocket': 'Polly Pocket',
      'princesas-disney': 'Princesas Disney',
      'rainbow-high': 'Rainbow High',
      'roblox': 'Roblox',
      'sonic-the-hedgehog': 'Sonic the Hedgehog',
      'sonny-angel': 'Sonny Angel',
      'spidey-and-amazing-friends': 'Spidey and Amazing Friends',
      'star-wars': 'Star Wars',
      'stumble-guys': 'Stumble Guys',
      'super-mario': 'Super Mario',
      'tartarugas-ninja': 'Tartarugas Ninja',
      'toy-story': 'Toy Story',
      'yu-gi-oh': 'Yu-Gi-Oh!'
    };

    const toLabel = (handle) => nameOverrides[handle] || handle
      .split('-')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');

    const normalize = (value) => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    // Search tolerates spacing and punctuation without changing displayed names
    // or the alphabetical order. Keep letters and numbers from any language.
    const searchKey = (value) => normalize(value).replace(/[^\p{L}\p{N}]/gu, '');

    // Only verified creation timestamps determine recency. The public library
    // remains alphabetical; editing or moving a source block changes no dates.
    const selectRecentCards = (cards) => {
      const seen = new Set();
      return cards.filter((item) => {
        const url = item.dataset.btCollectionUrl;
        const createdAt = Number(item.dataset.btCollectionCreatedAt);
        if (item.dataset.btCollectionState !== 'available' || !url || !Number.isFinite(createdAt) || createdAt <= 0 || seen.has(url)) return false;
        seen.add(url);
        return true;
      }).sort((a, b) => Number(b.dataset.btCollectionCreatedAt) - Number(a.dataset.btCollectionCreatedAt)
        || Number(b.dataset.btCollectionId) - Number(a.dataset.btCollectionId)).slice(0, 4);
    };

    const enhance = () => {
      const library = document.querySelector('[data-brand-library]');
      if (!library || library.dataset.enhanced === 'true') return;

      const search = library.closest('.bt-brand-library')?.querySelector('[data-brand-library-search]');
      const status = library.querySelector('[data-brand-library-status]');
      const reset = library.querySelector('[data-brand-library-reset]');
      const letterButtons = Array.from(library.querySelectorAll('[data-brand-library-letter]'));
      const discovery = document.querySelector('[data-brand-library-discovery]');
      const sourceSections = Array.from(document.querySelectorAll('.section-logo-list'));
      const sourceCards = Array.from(document.querySelectorAll('.section-logo-list .multicolumn-card[href*="/collections/"]'));
      const cards = sourceCards.map((card) => {
        const item = card.closest('li');
        const match = card.getAttribute('href').match(/\/collections\/([^/?#]+)/);
        if (!item || !match) return null;

        const handle = match[1];
        const information = card.querySelector('.multicolumn-card__info');
        const suppliedLabel = information?.querySelector('.multicolumn-card__text p');
        const label = suppliedLabel?.textContent.trim() || item.dataset.btCollectionTitle || toLabel(handle);
        item.classList.add('brand-library-item');
        item.classList.toggle('brand-library-item--text', !card.querySelector('img'));
        item.dataset.brandLibraryName = normalize(label);
        item.dataset.brandLibrarySearch = searchKey(label);
        item.dataset.brandLibraryInitial = normalize(label).charAt(0);
        card.setAttribute('aria-label', label);

        if (information && !information.querySelector('.brand-library-card-label')) {
          if (suppliedLabel) {
            suppliedLabel.classList.add('brand-library-card-label');
          } else {
            const labelElement = document.createElement('span');
            labelElement.className = 'brand-library-card-label';
            labelElement.textContent = label;
            information.appendChild(labelElement);
          }
        }

        return item;
      }).filter(Boolean);

      const cardList = sourceCards[0]?.closest('ul');
      if (cardList) {
        cards.sort((a, b) => a.dataset.brandLibraryName.localeCompare(b.dataset.brandLibraryName));
        cards.forEach((item) => cardList.appendChild(item));
      }

      const highlights = document.querySelector('[data-brand-library-highlights]');
      const highlightTemplate = highlights?.querySelector('[data-brand-library-highlight-template]');
      const highlightList = highlights?.querySelector('.bt-brand-library__features');
      let highlightSignature = '';
      const updateHighlights = () => {
        if (!highlightTemplate || !highlightList) return;
        const recent = selectRecentCards(cards);
        const signature = recent.map((item) => item.dataset.btCollectionUrl).join('|');
        if (signature === highlightSignature) return;
        highlightSignature = signature;
        highlightList.querySelectorAll('.bt-brand-library__feature').forEach((card) => card.remove());
        recent.forEach((item, index) => {
          const card = highlightTemplate.content.firstElementChild.cloneNode(true);
          const title = card.querySelector('.bt-brand-library__feature-title');
          title.textContent = item.querySelector('.brand-library-card-label')?.textContent || item.dataset.btCollectionTitle;
          title.id = `${library.id || library.closest('section').id || 'brand-library'}-recent-${index}`;
          card.href = item.dataset.btCollectionUrl;
          card.setAttribute('data-instant-navigation', '');
          card.setAttribute('aria-labelledby', title.id);
          const imageUrl = item.dataset.btCollectionHighlightImage;
          if (imageUrl) {
            const imageUrlObject = new URL(imageUrl, window.location.origin);
            const imageAtWidth = (width) => {
              const url = new URL(imageUrlObject);
              url.searchParams.set('width', String(width));
              return url.href;
            };
            const image240 = imageAtWidth(240);
            const image400 = imageAtWidth(400);
            const image600 = imageAtWidth(600);
            const image = document.createElement('img');
            image.src = image400;
            image.srcset = `${image240} 240w, ${image400} 400w, ${image600} 600w`;
            image.sizes = '(max-width: 640px) calc((100vw - 38px) / 2), (max-width: 989px) calc((100vw - 64px) / 2), 190px';
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            image.setAttribute('fetchpriority', 'low');
            image.width = 600;
            image.height = 450;
            card.querySelector('.bt-brand-library__feature-media').appendChild(image);
          }
          highlightList.appendChild(card);
        });
        highlights.hidden = recent.length === 0;
      };

      let selectedLetter = 'all';
      const filter = () => {
        const rawQuery = search ? search.value.trim() : '';
        const query = searchKey(rawQuery);
        const matchesQuery = (item) => !rawQuery || (query.length > 0 && item.dataset.brandLibrarySearch.includes(query));
        const matching = cards.filter((item) => !['pending', 'unavailable'].includes(item.dataset.btCollectionState) && matchesQuery(item));
        const initials = new Set(matching.map((item) => item.dataset.brandLibraryInitial));
        if (selectedLetter !== 'all' && !initials.has(selectedLetter)) selectedLetter = 'all';
        letterButtons.forEach((button) => {
          const letter = button.dataset.brandLibraryLetter;
          const unavailable = letter !== 'all' && !initials.has(letter);
          button.disabled = unavailable;
          button.setAttribute('aria-disabled', String(unavailable));
          button.title = unavailable ? library.dataset.unavailableLabel : '';
          button.setAttribute('aria-label', unavailable ? `${button.textContent.trim()}: ${library.dataset.unavailableLabel}` : button.textContent.trim());
          button.classList.toggle('is-active', letter === selectedLetter);
          button.setAttribute('aria-pressed', String(letter === selectedLetter));
        });
        let visible = 0;

        cards.forEach((item) => {
          const byLetter = selectedLetter === 'all' || item.dataset.brandLibraryInitial === selectedLetter;
          const byQuery = matchesQuery(item);
          const show = byLetter && byQuery && !['pending', 'unavailable'].includes(item.dataset.btCollectionState);
          item.hidden = !show;
          if (show) visible += 1;
        });

        if (discovery) discovery.hidden = true;
        sourceSections.forEach((sourceSection) => {
          const hasResults = Array.from(sourceSection.querySelectorAll('.brand-library-item')).some((item) => !item.hidden);
          sourceSection.classList.toggle('is-brand-library-visible', hasResults);
          sourceSection.classList.toggle('is-brand-library-empty', !hasResults);
        });
        if (status) status.textContent = visible === 0 ? library.dataset.emptyLabel : visible === 1 ? library.dataset.oneLabel : library.dataset.countLabel.replace('[count]', visible);
        if (reset) reset.hidden = visible > 0;
      };

      search?.addEventListener('input', () => { selectedLetter = 'all'; filter(); });
      document.addEventListener('brincatoys:collection-availability', () => { filter(); updateHighlights(); });
      letterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          selectedLetter = button.dataset.brandLibraryLetter || 'all';
          filter();
        });
      });
      reset?.addEventListener('click', () => {
        if (search) search.value = '';
        selectedLetter = 'all';
        filter();
        search?.focus();
      });
      library.dataset.enhanced = 'true';
      filter();
      updateHighlights();
    };

    enhance();
    document.addEventListener('shopify:section:load', enhance);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brincatoys-html-sitemap"]) return;
  try {
    
  (() => {
    const normalize = (value) => value
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
      .trim();

    const enhance = (root) => {
      if (!root || root.dataset.enhanced === 'true') return;

      const tools = root.querySelector('[data-sitemap-controls]');
      const search = root.querySelector('[data-sitemap-search]');
      const clear = root.querySelector('[data-sitemap-clear]');
      const count = root.querySelector('[data-sitemap-count]');
      const empty = root.querySelector('[data-sitemap-empty]');
      const showMore = root.querySelector('[data-sitemap-show-more]');
      const letterButtons = Array.from(root.querySelectorAll('[data-sitemap-letter]'));
      const items = Array.from(root.querySelectorAll('[data-sitemap-item]'));
      const limit = Number.parseInt(root.dataset.initialLimit || '32', 10);
      if (!tools || !search || !clear || !count || !empty || !showMore || items.length === 0) return;

      root.dataset.enhanced = 'true';
      const copy = {
        results: root.dataset.resultsLabel,
        singular: root.dataset.collectionSingular,
        plural: root.dataset.collectionPlural,
        of: root.dataset.ofLabel,
        shown: root.dataset.shownLabel,
        showAll: root.dataset.showAllTemplate,
        showLess: root.dataset.showLessLabel
      };
      const pluralize = (value) => `${value} ${value === 1 ? copy.singular : copy.plural}`;
      const entries = items.map((item) => {
        const label = normalize(item.textContent || '');
        const first = label.charAt(0);
        return { item, label, initial: /[0-9+]/.test(first) ? 'number' : first };
      });
      const availableInitials = new Set(entries.map((entry) => entry.initial));
      let selectedLetter = 'all';
      let expanded = false;

      letterButtons.forEach((button) => {
        const letter = button.dataset.sitemapLetter;
        button.disabled = letter !== 'all' && !availableInitials.has(letter);
      });

      const setActiveLetter = (letter) => {
        selectedLetter = letter;
        letterButtons.forEach((button) => {
          const active = button.dataset.sitemapLetter === letter;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', String(active));
        });
      };

      const filter = () => {
        const query = normalize(search.value);
        const matches = entries.filter((entry) => {
          const matchesSearch = query === '' || entry.label.includes(query);
          const matchesLetter = selectedLetter === 'all' || entry.initial === selectedLetter;
          return matchesSearch && matchesLetter;
        });
        const shouldLimit = query === '' && selectedLetter === 'all' && !expanded && matches.length > limit;

        entries.forEach((entry) => { entry.item.hidden = true; });
        matches.forEach((entry, index) => { entry.item.hidden = shouldLimit && index >= limit; });

        const shown = shouldLimit ? limit : matches.length;
        count.textContent = shown === matches.length
          ? `${copy.results}: ${pluralize(matches.length)}`
          : `${shown} ${copy.of} ${pluralize(matches.length)} ${copy.shown}`;
        empty.hidden = matches.length !== 0;
        clear.hidden = query === '';
        showMore.hidden = query !== '' || selectedLetter !== 'all' || matches.length <= limit;
        showMore.textContent = expanded ? copy.showLess : copy.showAll.replace('{count}', matches.length);
        showMore.setAttribute('aria-expanded', String(expanded));
      };

      search.addEventListener('input', () => {
        setActiveLetter('all');
        expanded = search.value.trim() !== '';
        filter();
      });
      clear.addEventListener('click', () => {
        search.value = '';
        expanded = false;
        setActiveLetter('all');
        filter();
        search.focus();
      });
      letterButtons.forEach((button) => {
        button.addEventListener('click', () => {
          search.value = '';
          expanded = button.dataset.sitemapLetter !== 'all';
          setActiveLetter(button.dataset.sitemapLetter);
          filter();
        });
      });
      showMore.addEventListener('click', () => {
        expanded = !expanded;
        filter();
        if (!expanded) root.querySelector('.bt-sitemap__collections').scrollIntoView({ block: 'start' });
      });

      tools.hidden = false;
      filter();
    };

    const enhanceAll = (scope = document) => {
      if (scope.matches?.('[data-bt-sitemap]')) enhance(scope);
      scope.querySelectorAll?.('[data-bt-sitemap]').forEach(enhance);
    };

    enhanceAll();
    if (!window.__btSitemapSectionListener) {
      window.__btSitemapSectionListener = true;
      document.addEventListener('shopify:section:load', (event) => enhanceAll(event.target));
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brincatoys-reviews"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (customElements.get('brincatoys-reviews')) return;

    class BrincatoysReviews extends HTMLElement {
      connectedCallback() {
        if (this.observer || this.visibilityObserver || this.initialized) return;
        if (!window.Shopify?.designMode && 'IntersectionObserver' in window) {
          this.visibilityObserver = new IntersectionObserver(entries => {
            if (!entries.some(entry => entry.isIntersecting)) return;
            this.visibilityObserver.disconnect();
            this.visibilityObserver = null;
            this.initialize();
          }, { rootMargin: '400px 0px' });
          this.visibilityObserver.observe(this);
          return;
        }
        this.initialize();
      }

      initialize() {
        if (this.observer || this.initialized) return;
        this.initialized = true;
        this.source = this.querySelector('[data-reviews-source]');
        this.presentation = this.querySelector('[data-reviews-presentation]');
        this.track = this.querySelector('.bt-reviews__track');
        if (!this.source || !this.presentation || !this.track) {
          this.initialized = false;
          return;
        }
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.progress = this.querySelector('.bt-reviews__progress');
        this.navigation = this.querySelector('.bt-reviews__navigation');
        this.lightbox = this.querySelector('.bt-reviews__lightbox');
        this.loadingMore = false;
        this.loadError = false;
        this.pendingReviewCount = 0;
        this.pendingScrollIndex = null;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.querySelector('[data-photo-close]').addEventListener('click', () => this.lightbox.close(), options);
        this.querySelector('[data-photo-previous]').addEventListener('click', () => this.showPhoto(this.photoIndex - 1), options);
        this.querySelector('[data-photo-next]').addEventListener('click', () => this.showPhoto(this.photoIndex + 1), options);
        this.lightbox.addEventListener('close', () => {
          this.querySelector('.bt-reviews__photo-stage').replaceChildren();
          this.photoTrigger?.focus({ preventScroll: true });
        }, options);
        this.lightbox.addEventListener('click', event => {
          if (event.target !== this.lightbox) return;
          const rect = this.lightbox.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.lightbox.close();
        }, options);
        this.lightbox.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          this.showPhoto(this.photoIndex + (event.key === 'ArrowLeft' ? -1 : 1));
        }, options);
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.nextReviews(), options);
        this.track.addEventListener('scroll', () => this.updateNavigation(), { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          if (event.key === 'Home' || event.key === 'End') this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: 'auto' });
          else if (event.key === 'ArrowRight') this.nextReviews();
          else this.move(-1);
        }, options);
        this.observer = new MutationObserver(() => this.scheduleSync());
        this.observer.observe(this.source, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['d', 'fill', 'src', 'hidden', 'disabled', 'data-brt-loaded', 'data-brt-total'] });
        if (window.ResizeObserver) {
          this.resizeObserver = new ResizeObserver(() => { this.updateNavigation(); this.updateTruncation(); });
          this.resizeObserver.observe(this.track);
        }
        this.sync();
      }

      disconnectedCallback() {
        if (this.lightbox?.open) this.lightbox.close();
        this.visibilityObserver?.disconnect();
        this.observer?.disconnect();
        this.__btReviewHydrationObserver?.disconnect();
        this.resizeObserver?.disconnect();
        this.events?.abort();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.layoutFrame);
        cancelAnimationFrame(this.__btReviewHydrationFrame);
        clearTimeout(this.sourceCleanupTimer);
        this.visibilityObserver = null;
        this.observer = null;
        this.__btReviewHydrationObserver = null;
        this.initialized = false;
        this.signature = null;
      }

      scheduleSync() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }

      readReviews() {
        const nativeRoot = this.source.querySelector('[data-brt-reviews]');
        if (nativeRoot) return this.readNativeReviews(nativeRoot);
        this.setLayout('carousel');
        // Reputon splits alternating reviews across two rows and duplicates each
        // row for its marquee. Interleave them, then remove exact duplicates.
        const rows = [...this.source.querySelectorAll('.reputon-carousel-holder')].map(row =>
          [...row.querySelectorAll('.reputon-single-review')]
        );
        if (!rows.length) rows.push([...this.source.querySelectorAll('.reputon-single-review')]);
        const seen = new Set();
        const result = [];
        const length = Math.max(0, ...rows.map(row => row.length));
        for (let index = 0; index < length; index++) {
          for (const row of rows) {
            const card = row[index];
            if (!card) continue;
            const name = card.querySelector('.reputon-reviewer-info .reputon-name')?.textContent.trim();
            const text = card.querySelector('.reputon-text')?.textContent.trim();
            const date = card.querySelector('.reputon-date')?.textContent.trim() || '';
            const stars = card.querySelector('.reputon-rating-stars');
            const avatar = this.imageUrl(card.querySelector('.reputon-link img')?.getAttribute('src'));
            const photos = [...new Set([...card.querySelectorAll('.reputon-small-images-media, .reputon-medium-images-media')].map(image => this.imageUrl(image.getAttribute('src'))).filter(Boolean))];
            // Only actual author reviews with a comment; no AI summaries or
            // empty ratings. The rating is copied, never used to select reviews.
            if (!name || !text || !stars) continue;
            const key = JSON.stringify([name, text, date]);
            if (seen.has(key)) continue;
            seen.add(key);
            result.push({ name, text, date, stars, avatar, photos, key });
            if (result.length >= 8) return result;
          }
        }
        return result;
      }

      readNativeReviews(nativeRoot) {
        this.setLayout(nativeRoot.dataset.layout === 'grid' ? 'grid' : 'carousel');
        const seen = new Set();
        const result = [];
        for (const card of nativeRoot.querySelectorAll('.brt-review')) {
          const name = card.querySelector('.brt-review__author')?.textContent.trim();
          const rawText = card.querySelector('.brt-review__text')?.textContent.trim() || '';
          const text = this.originalReviewText(rawText) || '';
          const date = card.querySelector('.brt-review__date')?.textContent.trim() || '';
          const sourceStars = card.querySelector('.brt-review__stars');
          if (sourceStars && !sourceStars.getAttribute('role')) sourceStars.setAttribute('role', 'img');
          const rating = Number(card.dataset.brtRating || sourceStars?.getAttribute('aria-label')?.match(/^[1-5](?=\s)/)?.[0]);
          if (!name || !Number.isInteger(rating) || rating < 1 || rating > 5) continue;
          const key = JSON.stringify([name, text, date, rating]);
          if (seen.has(key)) continue;
          seen.add(key);
          const avatar = this.imageUrl(card.querySelector('.brt-review__avatar')?.getAttribute('src'));
          const photos = [...new Set([...card.querySelectorAll('.brt-review__media-image')]
            .map(image => this.imageUrl(image.getAttribute('src')))
            .filter(Boolean))];
          result.push({ name, text, date, rating, stars: this.createNativeStars(rating), avatar, photos, key });
        }
        return result;
      }

      createNativeStars(rating) {
        const stars = this.element('div', '');
        for (let index = 0; index < 5; index++) {
          const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          svg.setAttribute('viewBox', '0 0 24 24');
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', 'M12 2.5 14.94 8.46 21.5 9.41 16.75 14.04 17.87 20.58 12 17.49 6.13 20.58 7.25 14.04 2.5 9.41 9.06 8.46Z');
          path.setAttribute('fill', index < rating ? 'currentColor' : 'none');
          path.setAttribute('stroke', 'currentColor');
          svg.append(path);
          stars.append(svg);
        }
        return stars;
      }

      originalReviewText(text) {
        // Some Google responses include an English translation before the
        // original. Display the author's original words, without duplicating it.
        if (!text?.startsWith('(Translated by Google)')) return text;
        const marker = /\r?\n\s*\(Original\)\s*\r?\n/.exec(text);
        return marker ? text.slice(marker.index + marker[0].length).trim() || text : text;
      }

      setLayout(layout) {
        const isGrid = layout === 'grid';
        this.dataset.layout = isGrid ? 'grid' : 'carousel';
        this.navigation.hidden = isGrid;
        if (isGrid) this.track.removeAttribute('tabindex');
        else this.track.tabIndex = 0;
      }

      sync() {
        if (!this.source || !this.track) return;
        const nativeRoot = this.source.querySelector('[data-brt-reviews]');
        const nativeMore = nativeRoot?.querySelector('[data-brt-load-more]');
        const nativePagination = nativeRoot?.querySelector('[data-brt-pagination]');
        this.totalReviews = Number(nativeRoot?.dataset.brtTotal) || this.totalReviews || 0;
        const reviews = this.readReviews();
        if (!reviews.length) {
          clearTimeout(this.sourceCleanupTimer);
          if (this.source.hidden) this.source.hidden = false;
          this.presentation.hidden = true;
          this.signature = null;
          return;
        }
        if (this.loadingMore) {
          const nativeStatus = nativeRoot?.querySelector('[data-brt-status]');
          if (reviews.length > this.pendingReviewCount) {
            this.loadingMore = false;
            this.loadError = false;
            this.pendingScrollIndex = this.pendingReviewCount;
          } else if (nativeStatus && !nativeStatus.hidden) {
            this.loadingMore = false;
            this.loadError = true;
          } else if (nativeMore && !nativeMore.disabled && (nativeMore.hidden || nativePagination?.hidden)) {
            this.loadingMore = false;
            this.loadError = this.totalReviews > reviews.length;
          }
        }
        const signature = JSON.stringify([this.dataset.layout, reviews.map(review => [review.key, review.stars.innerHTML, review.avatar, review.photos])]);
        if (signature === this.signature) {
          this.updateNavigation();
          this.scheduleSourceCleanup();
          return;
        }
        this.signature = signature;
        this.track.replaceChildren(...reviews.map((review, index) => this.createCard(review, index)));
        if (this.resizeObserver) {
          this.resizeObserver.disconnect();
          this.resizeObserver.observe(this.track);
          [...this.track.children].forEach(card => this.resizeObserver.observe(card));
        }
        this.presentation.hidden = false;
        if (!this.source.hidden) this.source.hidden = true;
        this.scheduleSourceCleanup();
        this.layoutFrame = requestAnimationFrame(() => {
          if (this.pendingScrollIndex !== null) {
            this.scrollToReview(this.pendingScrollIndex);
            this.pendingScrollIndex = null;
          }
          this.updateNavigation();
          this.updateTruncation();
        });
      }

      scheduleSourceCleanup() {
        clearTimeout(this.sourceCleanupTimer);
        if (this.source?.querySelector('[data-brt-load-more]:not([hidden])')) return;
        this.sourceCleanupTimer = setTimeout(() => {
          if (!this.source?.isConnected || this.presentation.hidden) return;
          this.observer?.disconnect();
          this.__btReviewHydrationObserver?.disconnect();
          cancelAnimationFrame(this.__btReviewHydrationFrame);
          this.source.remove();
          this.source = null;
          this.__btReviewHydrationObserver = null;
        }, 1500);
      }

      element(tag, className, text) {
        const element = document.createElement(tag);
        element.className = className;
        if (text !== undefined) element.textContent = text;
        return element;
      }

      imageUrl(value) {
        if (!value) return '';
        try {
          const url = new URL(value, window.location.href);
          return url.protocol === 'https:' ? url.href : '';
        } catch { return ''; }
      }

      photoLabel(review, index) {
        return this.dataset.photoLabel.replace('__author__', review.name).replace('__index__', index + 1);
      }

      showPhoto(index) {
        if (!this.photoReview || index < 0 || index >= this.photoReview.photos.length) return;
        this.photoIndex = index;
        const image = this.element('img', 'bt-reviews__full-photo');
        image.alt = this.photoLabel(this.photoReview, index);
        image.src = this.photoReview.photos[index];
        this.querySelector('.bt-reviews__photo-stage').replaceChildren(image);
        this.querySelector('[data-photo-progress]').textContent = (index + 1) + ' / ' + this.photoReview.photos.length;
        this.querySelector('[data-photo-previous]').disabled = index === 0;
        this.querySelector('[data-photo-next]').disabled = index === this.photoReview.photos.length - 1;
        this.querySelector('.bt-reviews__photo-navigation').hidden = this.photoReview.photos.length < 2;
      }

      createCard(review, index) {
        const card = this.element('li', 'bt-reviews__card');
        const author = this.element('div', 'bt-reviews__author');
        const avatar = this.element('span', 'bt-reviews__avatar', [...review.name][0]);
        avatar.setAttribute('aria-hidden', 'true');
        if (review.avatar) {
          const portrait = this.element('img', '');
          portrait.alt = '';
          portrait.width = 42;
          portrait.height = 42;
          portrait.loading = 'lazy';
          portrait.src = review.avatar;
          portrait.addEventListener('error', () => avatar.replaceChildren(document.createTextNode([...review.name][0])), { once: true });
          avatar.replaceChildren(portrait);
        }
        const byline = this.element('div', 'bt-reviews__byline');
        byline.append(this.element('span', 'bt-reviews__name', review.name), this.element('span', 'bt-reviews__date', review.date));
        author.append(avatar, byline);
        const stars = review.stars.cloneNode(true);
        stars.className = 'bt-reviews__stars';
        stars.replaceChildren(...[...review.stars.children].filter(node => node.localName === 'svg').map(node => node.cloneNode(true)));
        // Preserve the app's actual star shapes, including empty/half stars.
        // No numeric rating is inferred from SVG paths.
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', review.rating ? `${this.dataset.ratingLabel}: ${review.rating}/5` : this.dataset.ratingLabel);
        stars.querySelectorAll('svg').forEach(svg => svg.setAttribute('aria-hidden', 'true'));
        const rating = this.element('div', 'bt-reviews__rating');
        rating.append(stars, this.element('span', 'bt-reviews__origin', this.dataset.cardSource));
        const quote = this.element('blockquote', 'bt-reviews__quote');
        const text = this.element('p', 'bt-reviews__text', review.text);
        text.id = this.track.id + '-text-' + index;
        quote.append(text);
        const more = this.element('button', 'bt-reviews__more', this.dataset.moreLabel);
        more.type = 'button';
        more.hidden = true;
        more.setAttribute('aria-expanded', 'false');
        more.setAttribute('aria-controls', text.id);
        more.addEventListener('click', () => {
          const expanded = card.classList.toggle('is-expanded');
          more.setAttribute('aria-expanded', String(expanded));
          more.textContent = expanded ? this.dataset.lessLabel : this.dataset.moreLabel;
          this.updateTrackHeight();
        });
        const body = this.element('div', 'bt-reviews__body');
        const comment = this.element('div', 'bt-reviews__comment');
        comment.append(quote, more);
        body.append(comment);
        if (review.photos.length) {
          body.classList.add('bt-reviews__body--photo');
          const button = this.element('button', 'bt-reviews__photo');
          button.type = 'button';
          button.setAttribute('aria-haspopup', 'dialog');
          button.setAttribute('aria-label', this.dataset.openPhotosLabel.replace('__author__', review.name).replace('__count__', review.photos.length));
          const image = this.element('img', '');
          image.src = review.photos[0];
          image.alt = this.photoLabel(review, 0);
          image.width = 84;
          image.height = 84;
          image.loading = 'lazy';
          image.addEventListener('error', () => { button.hidden = true; body.classList.remove('bt-reviews__body--photo'); }, { once: true });
          button.append(image);
          if (review.photos.length > 1) button.append(this.element('span', 'bt-reviews__photo-count', '+' + (review.photos.length - 1)));
          button.addEventListener('click', () => {
            this.photoReview = review;
            this.photoTrigger = button;
            this.querySelector('[data-photo-author]').textContent = review.name;
            this.showPhoto(0);
            this.lightbox.showModal();
          });
          body.append(button);
        }
        card.append(author, rating, body);
        return card;
      }

      updateTruncation() {
        this.track.querySelectorAll('.bt-reviews__card').forEach(card => {
          const text = card.querySelector('.bt-reviews__text');
          card.querySelector('.bt-reviews__more').hidden = !card.classList.contains('is-expanded') && text.scrollHeight <= text.clientHeight + 1;
        });
        this.updateTrackHeight();
      }

      updateTrackHeight() {
        if (!this.track?.style) return;
        const trackRect = this.track.getBoundingClientRect();
        if (this.dataset.layout === 'grid' || !trackRect.width) {
          this.track.style.removeProperty('--review-track-height');
          return;
        }
        // Keep the complete text of expanded cards, but only reserve space
        // for cards inside the current horizontal viewport.
        const visibleHeights = [...this.track.children].map(card => card.getBoundingClientRect())
          .filter(rect => rect.right > trackRect.left + 4 && rect.left < trackRect.right - 4)
          .map(rect => rect.height);
        if (!visibleHeights.length) return;
        const style = getComputedStyle(this.track);
        const padding = (Number.parseFloat(style.paddingTop) || 0) + (Number.parseFloat(style.paddingBottom) || 0);
        const borders = (Number.parseFloat(style.borderTopWidth) || 0) + (Number.parseFloat(style.borderBottomWidth) || 0);
        const scrollbar = Math.max(0, this.track.offsetHeight - this.track.clientHeight - borders);
        const height = Math.ceil(Math.max(...visibleHeights) + padding + borders + scrollbar);
        this.track.style.setProperty('--review-track-height', height + 'px');
      }

      columns() {
        return Number.parseInt(getComputedStyle(this.track).getPropertyValue('--review-columns'), 10) || 1;
      }

      isAtEnd() {
        return this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      }

      hasMoreReviews() {
        const nativeMore = this.source?.querySelector('[data-brt-load-more]');
        const nativePagination = nativeMore?.closest('[data-brt-pagination]');
        return Boolean(nativeMore && !nativeMore.hidden && !nativeMore.disabled && !nativePagination?.hidden);
      }

      nextReviews() {
        if (this.dataset.layout === 'grid' || this.loadingMore) return;
        if (this.isAtEnd() && (this.hasMoreReviews() || this.loadError)) {
          this.loadNextBatch();
          return;
        }
        this.move(1);
      }

      loadNextBatch() {
        const nativeMore = this.source?.querySelector('[data-brt-load-more]');
        if (!nativeMore || nativeMore.hidden || nativeMore.disabled || this.loadingMore) return;
        this.pendingReviewCount = this.track.children.length;
        this.loadingMore = true;
        this.loadError = false;
        this.progress.textContent = this.dataset.loadingMoreLabel;
        this.next.disabled = true;
        nativeMore.click();
      }

      scrollToReview(index) {
        const card = this.track.children[0];
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollLeft = index * (card.getBoundingClientRect().width + gap);
      }

      move(direction) {
        if (this.dataset.layout === 'grid') return;
        // Mandatory scroll snapping can cancel scripted smooth scrolling in
        // Chromium/WebKit. An immediate snapped step keeps both controls
        // dependable and avoids a long main-thread animation.
        this.track.scrollBy({ left: direction * (this.track.clientWidth + 16), behavior: 'auto' });
      }

      updateNavigation() {
        this.updateTrackHeight();
        if (this.dataset.layout === 'grid') {
          this.progress.textContent = '';
          return;
        }
        const total = this.track.children.length;
        const columns = this.columns();
        const step = this.track.children[0]?.getBoundingClientRect().width + 16;
        const start = Math.min(Math.max(0, total - columns), step ? Math.round(this.track.scrollLeft / step) : 0);
        this.previous.disabled = this.track.scrollLeft <= 2;
        this.next.disabled = this.loadingMore || (this.isAtEnd() && !this.hasMoreReviews() && !this.loadError);
        const end = Math.min(total, start + columns);
        const range = start + 1 === end ? String(end) : (start + 1) + '–' + end;
        this.progress.textContent = this.loadingMore
          ? this.dataset.loadingMoreLabel
          : this.loadError
            ? this.dataset.loadErrorLabel
            : range + ' ' + this.dataset.progressLabel + ' ' + Math.max(total, this.totalReviews || 0);
      }
    }
    customElements.define('brincatoys-reviews', BrincatoysReviews);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brincatoys-tales-library"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('brincatoys-tales-library')) {
    customElements.define('brincatoys-tales-library', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.input = this.querySelector('[data-tales-search]');
        this.cards = [...this.querySelectorAll('[data-tales-card]')];
        this.filters = [...this.querySelectorAll('[data-tales-filter]')];
        this.clearButton = this.querySelector('[data-tales-clear]');
        this.emptyState = this.querySelector('[data-tales-empty]');
        this.emptyClear = this.querySelector('[data-tales-empty-clear]');
        this.status = this.querySelector('[data-tales-status]');
        this.activeFilter = 'all';
        this.input?.addEventListener('input', () => this.applyFilters());
        this.input?.addEventListener('search', () => this.applyFilters());
        this.filters.forEach((button) => button.addEventListener('click', () => {
          this.activeFilter = button.dataset.talesFilter;
          this.filters.forEach((filter) => {
            const active = filter === button;
            filter.classList.toggle('is-active', active);
            filter.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          this.applyFilters();
        }));
        this.clearButton?.addEventListener('click', () => this.resetFilters());
        this.emptyClear?.addEventListener('click', () => this.resetFilters());
        this.applyFilters(false);
      }

      normalize(value) {
        return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
      }

      applyFilters(announce = true) {
        const query = this.normalize(this.input?.value || '');
        const refining = Boolean(query) || this.activeFilter !== 'all';
        let visibleCount = 0;
        this.cards.forEach((card) => {
          const readingTime = Number(card.dataset.reading || 0);
          const matchesQuery = !query || this.normalize(card.dataset.search || '').includes(query);
          const matchesTime = this.activeFilter === 'all'
            || (this.activeFilter === 'short' && readingTime <= 3)
            || (this.activeFilter === 'medium' && readingTime === 4)
            || (this.activeFilter === 'long' && readingTime >= 5);
          const visible = matchesQuery && matchesTime
            && (!card.hasAttribute('data-tales-featured-result') || refining);
          card.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
        if (this.clearButton) this.clearButton.hidden = !query && this.activeFilter === 'all';
        if (announce && this.status) {
          this.status.textContent = visibleCount === 1
            ? this.dataset.resultsSingular
            : `${visibleCount} ${this.dataset.resultsPlural}`;
        }
      }

      resetFilters() {
        if (this.input) this.input.value = '';
        this.activeFilter = 'all';
        this.filters.forEach((filter) => {
          const active = filter.dataset.talesFilter === 'all';
          filter.classList.toggle('is-active', active);
          filter.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        this.applyFilters();
        this.input?.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brincatoys-trust-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.bt-confidence__ages';
    const afterLayout = (callback) => requestAnimationFrame(() => requestAnimationFrame(callback));

    const getVisibleBanner = () => {
      const banner = document.querySelector('#shopify-pc__banner');
      return banner && banner.getBoundingClientRect().height > 0 ? banner : null;
    };

    const resetListClamp = (list) => {
      list.style.removeProperty('max-height');
      list.style.removeProperty('overflow-y');
      list.style.removeProperty('overscroll-behavior');
    };

    const adjustMenu = (details) => {
      const list = details.querySelector('ul');
      if (!list) return;

      resetListClamp(list);
      if (!details.open) return;

      afterLayout(() => {
        const banner = getVisibleBanner();
        if (!banner) return;

        const bottomLimit = banner.getBoundingClientRect().top - 12;
        const overflow = details.getBoundingClientRect().bottom - bottomLimit;
        if (overflow > 0) {
          window.scrollTo({ top: window.scrollY + overflow, behavior: 'auto' });
        }

        afterLayout(() => {
          const visibleBanner = getVisibleBanner();
          if (!visibleBanner) return;

          const stickyHeader = document.querySelector('.shopify-section-header-sticky');
          const headerBottom = stickyHeader ? Math.max(0, stickyHeader.getBoundingClientRect().bottom) : 0;
          const safeTop = headerBottom + 8;
          const precedingCta = details.previousElementSibling?.matches('.bt-confidence__cta')
            ? details.previousElementSibling
            : null;
          const ctaTopOverflow = precedingCta ? safeTop - precedingCta.getBoundingClientRect().top : 0;
          const heroHeading = details.closest('.bt-confidence')?.querySelector('.bt-confidence__heading');
          const headingTopOverflow = heroHeading && getComputedStyle(heroHeading).display !== 'none'
            ? safeTop - heroHeading.getBoundingClientRect().top
            : 0;
          const topOverflow = Math.max(safeTop - details.getBoundingClientRect().top, ctaTopOverflow, headingTopOverflow);
          if (topOverflow > 0) {
            window.scrollTo({ top: Math.max(0, window.scrollY - topOverflow), behavior: 'auto' });
          }

          afterLayout(() => {
            const latestBanner = getVisibleBanner();
            if (!latestBanner) return;

            const availableListHeight = latestBanner.getBoundingClientRect().top - 12 - list.getBoundingClientRect().top;
            if (list.scrollHeight > availableListHeight + 1) {
              list.style.maxHeight = `${Math.max(44, availableListHeight)}px`;
              list.style.overflowY = 'auto';
              list.style.overscrollBehavior = 'contain';
            }
          });
        });
      });
    };

    const bindMenus = (root = document) => {
      root.querySelectorAll(selector).forEach((details) => {
        if (details.dataset.btConsentScrollBound === 'true') return;

        details.dataset.btConsentScrollBound = 'true';
        details.addEventListener('toggle', () => adjustMenu(details));
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindMenus(), { once: true });
    } else {
      bindMenus();
    }

    document.addEventListener('shopify:section:load', (event) => bindMenus(event.target));
    window.addEventListener('resize', () => {
      document.querySelectorAll(`${selector}[open]`).forEach((details) => adjustMenu(details));
    }, { passive: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-discovery"]) return;
  try {
    
  if (!customElements.get('bt-discovery-routes')) {
    customElements.define('bt-discovery-routes', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.panelObserver?.disconnect();
        this.controller = new AbortController();
        const { signal } = this.controller;
        this.panelObserver = 'ResizeObserver' in window
          ? new window.ResizeObserver(() => this.queuePanelSync())
          : null;

        this.addEventListener('toggle', (event) => {
          if (event.target.matches('details[open]')) {
            this.querySelectorAll('details[open]').forEach((details) => {
              if (details !== event.target) details.open = false;
            });
            if (window.matchMedia('(max-width: 749px)').matches) {
              window.requestAnimationFrame(() => {
                event.target.querySelector('.bt-category-discovery__route-panel')?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
              });
            }
          }
          this.queuePanelSync();
        }, { capture: true, signal });

        window.addEventListener('resize', () => this.queuePanelSync(), { signal });
        window.addEventListener('hashchange', () => this.openFragmentChoice(), { signal });

        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-close-discovery]');
          if (button) this.closeDisclosure(button.closest('details'), true);
        }, { signal });

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;
          const details = this.querySelector('details[open]');
          if (details) {
            event.preventDefault();
            this.closeDisclosure(details, true);
          }
        }, { signal });

        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) {
            this.querySelectorAll('details[open]').forEach((details) => this.closeDisclosure(details));
          }
        }, { signal });

        this.openFragmentChoice();
        this.queuePanelSync();
      }

      openFragmentChoice() {
        const { hash } = window.location;
        if (!['#escolher-idade', '#escolher-orcamento'].includes(hash)) return;

        const panel = this.querySelector(hash);
        const details = panel?.closest('details');
        if (!details || details.open) return;

        details.open = true;
        this.queuePanelSync();
        window.cancelAnimationFrame(this.fragmentScrollFrame);
        this.fragmentScrollFrame = window.requestAnimationFrame(() => {
          if (this.isConnected && details.open) panel.scrollIntoView({ block: 'start', behavior: 'instant' });
        });
      }

      queuePanelSync() {
        window.cancelAnimationFrame(this.panelSyncFrame);
        this.panelSyncFrame = window.requestAnimationFrame(() => {
          this.panelSyncFrame = null;
          this.syncPanelSpace();
        });
      }

      syncPanelSpace() {
        const panel = this.querySelector('details[open] .bt-category-discovery__route-panel');

        if (panel !== this.observedPanel) {
          if (this.observedPanel) this.panelObserver?.unobserve(this.observedPanel);
          if (panel) this.panelObserver?.observe(panel);
          this.observedPanel = panel;
        }

        if (!panel) {
          this.style.removeProperty('--bt-discovery-panel-space');
          return;
        }

        const panelHeight = Math.ceil(panel.getBoundingClientRect().height);
        this.style.setProperty('--bt-discovery-panel-space', `${panelHeight + 8}px`);
      }

      closeDisclosure(details, restoreFocus = false) {
        if (!details) return;
        details.open = false;
        if (restoreFocus) details.querySelector('summary').focus();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.panelObserver?.disconnect();
        window.cancelAnimationFrame(this.panelSyncFrame);
        window.cancelAnimationFrame(this.fragmentScrollFrame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('custom-accordion').then(() => {
    class FooterAccordion extends CustomAccordion {
      constructor() {
        super();
        this.wasDesktop = window.matchMedia('(min-width: 750px)').matches;
        this.updateOpenState();
        window.addEventListener('resizeend', this.updateOpenState.bind(this));
      }

      updateOpenState() {
        if (window.matchMedia('(min-width: 750px)').matches) {
          this.detailsElem.open = true;
          this.summaryElem.setAttribute('tabindex', '-1');
          this.summaryElem.classList.add('pointer-events-none');
          this.wasDesktop = true;
        } else if (this.wasDesktop) {
          this.detailsElem.open = false;
          this.summaryElem.removeAttribute('tabindex');
          this.summaryElem.classList.remove('pointer-events-none');
          this.wasDesktop = false;
        }
      }
    }

    customElements.define('footer-accordion', FooterAccordion);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.headerHeight = this.header.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
      document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);

      window.addEventListener('resizeend', () => {
        // Only update height once per resize cycle, off the main thread
        requestAnimationFrame(() => {
          this.headerHeight = this.header.offsetHeight;
          document.documentElement.style.setProperty('--header-height', `${this.headerHeight}px`);
          document.documentElement.style.setProperty('--header-height-live', `${this.headerHeight}px`);
        });
      });

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.lastScrollTrigger = 0;
      this.scrollThreshold = 50;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      this.searchButton = this.querySelector('.header__icon--search');
      if (this.searchButton) {
        this.searchButton.addEventListener('click', this.searchButtonClick.bind(this));
      }

      this.createObserver();
    }

    searchButtonClick() {
      this.preventHide = true;
      requestAnimationFrame(() => (this.preventHide = false));
    }

    // Defer the DOM write to avoid synchronous reflow
    setHeaderHeightLive(event, zero) {
      requestAnimationFrame(() => {
        const isVisible = !this.header.classList.contains('shopify-section-header-hidden');
        const height = (zero || !isVisible) ? 0 : this.header.offsetHeight;
        document.documentElement.style.setProperty('--header-height-live', `${height}px`);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      requestAnimationFrame(() => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        // Only trigger actions if the scroll has changed by at least the threshold value
        if (Math.abs(scrollTop - this.lastScrollTrigger) < this.scrollThreshold) return;

        const scrollDifference = scrollTop - this.currentScrollTop;
        // Handle scrolling classes based on 50px sensitivity
        if (scrollDifference > 50 && this.pauseScrollListen !== true) {
          // Scrolling down
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-down');
          this.header.classList.remove('scrolling-up');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        } else if (scrollDifference < -50 && this.pauseScrollListen !== true) {
          // Scrolling up
          this.pauseScrollListen = true;
          this.header.classList.add('scrolling-up');
          this.header.classList.remove('scrolling-down');
          setTimeout(() => {
            this.setHeaderHeightLive();
            this.pauseScrollListen = false;
          }, 320);
        }

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling down
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          // Main logic for scrolling up
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          // Reset at the top
          this.header.classList.remove('scrolled-past-header');
          this.header.classList.remove('scrolling-down');
          this.header.classList.remove('scrolling-up');
          requestAnimationFrame(this.reset.bind(this));
          setTimeout(() => {
            this.setHeaderHeightLive();
          }, 320);
        }

        this.currentScrollTop = scrollTop;
        this.lastScrollTrigger = scrollTop; // Update the last scroll position that triggered an action
      });
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
      this.setHeaderHeightLive(null, true);
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      this.setHeaderHeightLive();
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close?.(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lego-discovery"]) return;
  try {
    
  if (!customElements.get('bt-lego-routes')) {
    customElements.define('bt-lego-routes', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.addEventListener('click', (event) => {
          const link = event.target.closest?.('a.bt-lego-discovery__route');
          if (!link || !this.contains(link)) return;
          const filterSelector = this.filterSelector(link.dataset.legoBehavior);
          if (filterSelector && this.openFilterDrawer(event, link, filterSelector)) return;
          this.followSamePageAnchor(event, link, filterSelector);
        }, { signal: this.events.signal });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }

      filterSelector(behavior) {
        if (behavior === 'age-filter') return 'input[name="filter.p.product_type"]';
        if (behavior === 'price-filter') return 'input[name="filter.v.price.lte"]';
        return '';
      }

      openFilterDrawer(event, link, filterSelector) {
        const disclosure = document.querySelector('details.mobile-facets__disclosure');
        const launcher = disclosure?.querySelector(':scope > summary');
        const drawerHost = disclosure?.closest('facet-filters-form');
        const form = disclosure?.querySelector('#FacetFiltersFormMobile');
        const facetsContainer = disclosure?.closest('.facets-container');
        if (!disclosure || !launcher || !drawerHost || !form) return false;
        const mobileOnly = drawerHost.classList.contains('medium-hide') || drawerHost.classList.contains('large-up-hide');
        if (mobileOnly && !window.matchMedia('(max-width: 749px)').matches) return false;
        event.preventDefault();
        this.updateLocation(new URL(link.href, window.location.href));
        facetsContainer?.classList.add('bt-lego-route-drawer-open');
        const releaseDrawerLayer = () => {
          if (disclosure.open) return;
          facetsContainer?.classList.remove('bt-lego-route-drawer-open');
          disclosure.removeEventListener('toggle', releaseDrawerLayer);
        };
        disclosure.addEventListener('toggle', releaseDrawerLayer);
        if (!disclosure.open) launcher.click();
        if (!disclosure.open) {
          releaseDrawerLayer();
          return false;
        }
        requestAnimationFrame(() => this.revealFilter(form, filterSelector));
        return true;
      }

      followSamePageAnchor(event, link, filterSelector = '') {
        const destination = new URL(link.href, window.location.href);
        if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || destination.search !== window.location.search || !destination.hash) return false;
        let target;
        try {
          target = document.querySelector(destination.hash);
        } catch {
          return false;
        }
        if (!target) return false;
        event.preventDefault();
        this.updateLocation(destination);
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        target.scrollIntoView({ behavior, block: 'start' });
        if (filterSelector) {
          requestAnimationFrame(() => this.revealFilter(document.querySelector('#FacetFiltersForm'), filterSelector));
        }
        return true;
      }

      revealFilter(form, filterSelector) {
        const input = form?.querySelector(filterSelector);
        const details = input?.closest('details');
        const summary = details?.querySelector(':scope > summary');
        if (!details || !summary) return;
        if (!details.open) summary.click();
        summary.focus({ preventScroll: true });
      }

      updateLocation(destination) {
        const url = window.location.pathname + window.location.search + destination.hash;
        if (window.location.hash === destination.hash) {
          window.history.replaceState({}, '', url);
        } else {
          window.history.pushState({}, '', url);
        }
      }
    });
  }

  (() => {
    const nameOverrides = {
      'lego-city': 'LEGO City',
      'lego-classic': 'LEGO Classic',
      'lego-creator': 'LEGO Creator',
      'lego-dc-comics': 'LEGO DC',
      'lego-ninjago': 'LEGO NINJAGO',
      'lego-star-wars': 'LEGO Star Wars',
      'lego-technic': 'LEGO Technic',
      'lego-speed-champions': 'LEGO Speed Champions',
      'lego-friends': 'LEGO Friends',
      'lego-disney': 'LEGO Disney',
      'lego-marvel': 'LEGO Marvel',
      'lego-duplo': 'LEGO DUPLO',
      'lego-botanicals': 'LEGO Botanicals',
      'lego-jurassic-world': 'LEGO Jurassic World',
      'lego-minecraft': 'LEGO Minecraft',
      'lego-sonic': 'LEGO Sonic',
      'lego-dreamzzz': 'LEGO DREAMZzz',
      'lego-harry-potter': 'LEGO Harry Potter',
      'lego-animal-crossing': 'LEGO Animal Crossing',
      'lego-hidden-side': 'LEGO Hidden Side'
    };

    const enhance = () => {
      const library = document.querySelector('#lego-collection-library');
      if (!library || library.dataset.enhanced === 'true') return;
      const discovery = library.closest('.bt-lego-discovery');
      const localizedNameOverrides = {
        ...nameOverrides,
        'outras-colecoes': discovery?.dataset.otherCollectionsLabel || 'LEGO'
      };
      const fallbackLabel = discovery?.dataset.collectionFallback || 'LEGO';

      const cards = Array.from(document.querySelectorAll('.section-logo-list .multicolumn-card[href*="/collections/lego"], .section-logo-list .multicolumn-card[href*="/collections/outras-colecoes"]'));
      cards.forEach((card) => {
        const match = card.getAttribute('href').match(/\/collections\/([^/?#]+)/);
        if (!match) return;

        const label = localizedNameOverrides[match[1]] || fallbackLabel;
        card.setAttribute('aria-label', label);
        const information = card.querySelector('.multicolumn-card__info');
        if (information && !information.querySelector('.lego-library-card-label')) {
          const labelElement = document.createElement('span');
          labelElement.className = 'lego-library-card-label';
          labelElement.textContent = label;
          information.appendChild(labelElement);
        }
      });

      library.dataset.enhanced = 'true';
    };

    enhance();
    document.addEventListener('shopify:section:load', enhance);
  })();

  } catch(e) { console.error(e); }
})();
})();
